import React from 'react';
import PropTypes from 'prop-types';

import RentPaymentTypeEnum from '../../../constants/enums/RentPaymentTypeEnum';
import { isCardExpired } from '../../../helpers/isCardExpired';
import { EnumPaymentMethodStatusTypes } from '../../../pages/enums';
import paymentMethodPropTypes from '../../../prop-types/payment-method-prop-types';
import SelectionBox from '../../DesignSystemComponents/SelectionBox';
import PaymentMethodInfo from '../PaymentMethodInfo';

const getStatus = (paymentMethod) => {
  let disabled = false;
  let reason = null;
  if (
    paymentMethod.source_status === EnumPaymentMethodStatusTypes.NEW &&
    paymentMethod.type === RentPaymentTypeEnum.BANK_ACCOUNT
  ) {
    disabled = true;
    reason = 'Your bank account is not yet verified';
  } else if (paymentMethod.source_status === 'login_expired') {
    disabled = true;
    reason = 'Please log in to Plaid again';
  } else if (
    paymentMethod.expiration &&
    isCardExpired(paymentMethod.expiration)
  ) {
    disabled = true;
    reason = 'Your card expired';
  }
  return { disabled, reason };
};

const PaymentMethodSelectionBox = ({
  paymentMethods,
  selected,
  hideDescription,
  hideLabels,
  onChange,
}) => {
  return (
    <SelectionBox
      selectionType="radio"
      selected={selected}
      onChange={onChange}
      vertical
    >
      {paymentMethods.map((paymentMethod) => {
        const { disabled, reason } = getStatus(paymentMethod);
        return (
          <SelectionBox.Item
            key={paymentMethod.id}
            value={paymentMethod.id}
            disabled={disabled}
            disabledReason={reason}
          >
            <PaymentMethodInfo
              hideDescription={hideDescription}
              hideLabels={hideLabels}
              paymentMethod={paymentMethod}
            />
          </SelectionBox.Item>
        );
      })}
    </SelectionBox>
  );
};

PaymentMethodSelectionBox.propTypes = {
  selected: PropTypes.string,
  hideDescription: PropTypes.bool,
  hideLabels: PropTypes.bool,
  onChange: PropTypes.func,
  paymentMethods: PropTypes.arrayOf(paymentMethodPropTypes).isRequired,
};

export default PaymentMethodSelectionBox;
